import type { VoteOnPoll200OptionsItemAllOf } from './voteOnPoll200OptionsItemAllOf';
import type { VoteOnPoll200OptionsItemAllOfTwo } from './voteOnPoll200OptionsItemAllOfTwo';

export type VoteOnPoll200OptionsItem = VoteOnPoll200OptionsItemAllOf & VoteOnPoll200OptionsItemAllOfTwo;
